import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-note41',
  templateUrl: './note41.component.html',
  styleUrls: ['./note41.component.scss'],
})
export class Note41Component implements OnInit {
  note41Form: FormGroup;

  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      this.setForm();

      if (
        data.noteId === Notes.Note41 &&
        data.response.userInputData !== null &&
        data.response.userInputData !== undefined &&
        data.response.userInputData.data !== null &&
        data.response.userInputData.data !== undefined
      ) {
        this.editNotes41(data.response.userInputData.data);
      }
    });
  }

  setForm(): void {
    this.note41Form = new FormGroup({
      textbox1: new FormControl(''),
      textbox2: new FormControl(''),
      textbox3: new FormControl(''),
    });
  }

  editNotes41(res): void {
    this.note41Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : '',
      textbox2: res.textbox2 ? res.textbox2 : '',
      textbox3: res.textbox3 ? res.textbox3 : '',
    });
  }
}
